import { render, staticRenderFns } from "./PhotoInput.vue?vue&type=template&id=2488d1ab&scoped=true&"
import script from "./PhotoInput.vue?vue&type=script&lang=js&"
export * from "./PhotoInput.vue?vue&type=script&lang=js&"
import style0 from "./PhotoInput.vue?vue&type=style&index=0&id=2488d1ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2488d1ab",
  null
  
)

export default component.exports